import React, { ReactNode } from "react";
import { PreScreeningCaptureItemSpec } from "@pages/home/preprocess/PreScreening";
import {
  CrfCheckItemSpec,
  CrfSingleSelectItemSpec,
  InitialCrfPageSequence,
  InitialItemSequence,
  InitialVisitSequence,
} from "maven-lib/dist/consts/edc";
import { EcoaQuestionnaire } from "maven-lib/dist/dto/entity/ecoaVisit";
import { VisitQuestionnaireItem } from "../../ecoa/questionnaire/VisitQuestionnaireItem";
import { VisitQuestionnaireWrapper } from "../../ecoa/questionnaire/VisitQuestionnaireWrapper";

interface PreScreeningSingleQuestionnaireProps {
  screeningCaptureData: Array<{
    itemId: string | null;
    dbVal: string | number | null;
    sectionId: string;
  }>;
  questionnaire: EcoaQuestionnaire;
  onChangeAnswers: (answers: Array<PreScreeningCaptureItemSpec>) => void;
  onChangeDisabledFooter: (val: boolean) => void;
  children: ReactNode;
}

export function PreScreeningSingleQuestionnaire({
  screeningCaptureData,
  questionnaire,
  onChangeAnswers,
  onChangeDisabledFooter,
  children,
}: PreScreeningSingleQuestionnaireProps) {
  const handleChangeAnswers = (answers: Array<{ itemId: string | null; dbVal: string | number | null }>): void => {
    const { folderId, visitId, crfPageId, sectionId } = questionnaire.item;
    onChangeAnswers(
      answers.map((ans) => ({
        folderId,
        visitId,
        visitSeq: InitialVisitSequence,
        crfPageId,
        crfPageSeq: InitialCrfPageSequence,
        sectionId,
        itemId: ans.itemId || "",
        itemSeq: InitialItemSequence,
        dbVal: ans.dbVal,
      }))
    );
  };

  const defaultValues = ((questionnaire) => {
    if (questionnaire.item.original.type === "CHECK") {
      const checkItem: CrfCheckItemSpec = questionnaire.item.original;
      const item = checkItem.itemCode.codes.map(({ id: itemId }) => ({
        itemId,
        dbVal: screeningCaptureData.find((item) => item.itemId === itemId)?.dbVal || null,
      }));
      const typeTextItems = checkItem.itemCode.codes
        .map(({ typeText }) => ({
          itemId: typeText?.id || "",
          dbVal: screeningCaptureData.find((item) => item.itemId === typeText?.id || "")?.dbVal || null,
        }))
        .filter(({ itemId }) => itemId !== "");

      return [...item, ...typeTextItems];
    } else if (questionnaire.item.original.type === "SINGLE_SELECT") {
      const selectItem: CrfSingleSelectItemSpec = questionnaire.item.original;
      const typeTextItems = selectItem.itemCode.codes
        .map(({ typeText }) => ({
          itemId: typeText?.id || "",
          dbVal: screeningCaptureData.find((item) => item.itemId === typeText?.id || "")?.dbVal || null,
        }))
        .filter(({ itemId }) => itemId !== "");

      return [
        {
          itemId: questionnaire.item.id,
          dbVal: screeningCaptureData.find((item) => item.itemId === questionnaire.item.id)?.dbVal || null,
        },
        ...typeTextItems,
      ];
    } else {
      return [
        {
          itemId: questionnaire.item.id,
          dbVal: screeningCaptureData.find((item) => item.itemId === questionnaire.item.id)?.dbVal || null,
        },
      ];
    }
  })(questionnaire);

  return (
    <VisitQuestionnaireWrapper
      title={questionnaire.title}
      question={questionnaire.question}
      icon={questionnaire.item?.original?.labelIcon}
      text={questionnaire.text}
    >
      <VisitQuestionnaireItem
        isAvailable
        questionnaire={questionnaire}
        defaultItemValues={defaultValues}
        onValueChange={handleChangeAnswers}
        onChangeDisabledFooter={onChangeDisabledFooter}
      />
      {children}
    </VisitQuestionnaireWrapper>
  );
}
